import { render, staticRenderFns } from "./HomeNew.vue?vue&type=template&id=f710cad8&scoped=true"
import script from "./HomeNew.vue?vue&type=script&lang=js"
export * from "./HomeNew.vue?vue&type=script&lang=js"
import style0 from "./HomeNew.vue?vue&type=style&index=0&id=f710cad8&prod&scoped=true&lang=css"
import style1 from "./HomeNew.vue?vue&type=style&index=1&id=f710cad8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f710cad8",
  null
  
)

export default component.exports